/// <amd-module name="Artifacts/Conda/redux/Module" />
import { PackageModule } from "Artifacts/Package/redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _CondaModule: ISagaModule<Record<string, never>> = {
  id: "conda-protocol-module",
  reducerMap: {},
};

export const CondaModule = [PackageModule, _CondaModule];
